import { Component } from "react";
import DataTable from "react-data-table-component";
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer";
import axios from "../../../axios";
import classes from "./bookings.css"
import BookingModal from "./BookingModal/BookingModal"

const columns = [
  { name: "Datum", selector: "date", minWidth: "150px", maxWidth: "150px", sortable: true, left: true, format: row => row.date ? (new Date(row.date * 1000).toLocaleDateString("en-GB")) : "", style: { fontSize: "14px" }, sortFunction: timestampSort },
  { name: "Richting", selector: "direction", grow: 2, sortable: true, left: true, cell: row => {
    return <div className={classes.indicator} style={{ backgroundColor: (row.direction === "in" ? "#CCF0DC" : "#FFEAA7"), color: (row.direction === "in" ? "#356244" : "#D09D00")}}>{(row.direction === "in" ? "Inkomend" : "Uitgaand")}</div>
  }},
  { name: "Bedrag", selector: "amount", grow: 2, sortable: true, left: true, format: (row) => row.amount ? ("€ " + parseFloat(row.amount).toLocaleString("de-DE")) : "", style: { fontSize: "14px" }},
  { name: "Partij", selector: "party", grow: 2, sortable: true, style: { fontSize: "15px" } },
  { name: "Beschrijving", selector: "description", grow: 5, sortable: false, style: { fontSize: "15px" } },
]

class Bookings extends Component {

  state = {
    bookings: [],
    selectedBooking: null,
    showModal: false,
  }


  componentDidMount() {
    this.refreshData()
  }

  refreshData() {

    axios.get("/financial-bookings").then(response => {
      if (response.data) {
        this.setState({ bookings: response.data })
      }
    })
  }

  displayModal = (shouldBeShown, invoice) => {

    // Update state to show
    this.setState({ showModal: shouldBeShown, selectedBooking: invoice })

    // Update list after update
    if (shouldBeShown === false) {
      setTimeout(() => this.refreshData(), 500)
    }
  }

  render() {
    return (
      <ContentContainer title="Directe boekingen">
        <button onClick={() => this.displayModal(true)} className={classes.addButton}>Upload</button>

        <DataTable
          columns={columns}
          data={this.state.bookings}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          defaultSortField={"date"}
          defaultSortAsc={false}
          customStyles={{ headCells: { style: { fontWeight: "bold", fontSize: "15px" }} }}
          onRowClicked={(el) => this.displayModal(true, el)}
        />


        {this.state.showModal && <>
          <BookingModal
            shouldShow={this.state.showModal}
            selectedBooking={this.state.selectedBooking}
            closeModal={() => this.displayModal(false, null)}/>
          </>
        }

      </ContentContainer>
    );
  }
}


// MARK: - Helpers

function timestampSort(a, b) {
  if (a.date === b.date) {
    return 1
  } else {
    return a.date > b.date
  }
}

export default Bookings;
